import React from "react"
import ViewToPrintTriage from "../components/RPMCriticalInitialScreen/ViewToPrintTriage/ViewToPrintTriage"

const RPMViewToPrintTriageInitialScreen = () => <ViewToPrintTriage />

export default RPMViewToPrintTriageInitialScreen
